import {OfferAgent} from './offer';
import {JobsAgent} from './jobs';
import {PhrasebookAgent} from './phrasebook';
import {HomepageBlogAgent} from './homepage-blog';
import {RedirectsAgent} from './redirects';
import {ContentOverridesAgent} from './content-overrides';
import {SeqOffersAgent} from './seq-offers';
import {PopupsAgent} from './popups';
import {FAQAgent} from './faq';
import {UserAgent} from './users';
import {AccessAgent} from './access';
import {LocaleAgent} from './locale';
import {LanguagesAgent} from './languages';
import {WebsiteAgent} from './website';
import {SeopagesAgent} from './seopages';
import {ColdTrafficAgent} from './ct';
import { AffiliateKitItemAgent } from './affiliate-kit-items';

export const agent = {
    users: new UserAgent(),
    access: new AccessAgent(),
    locales: new LocaleAgent(),
    offer: new OfferAgent(),
    jobs: new JobsAgent(),
    phrasebook: new PhrasebookAgent(),
    homepageBlog: new HomepageBlogAgent(),
    redirects: new RedirectsAgent(),
    popups: new PopupsAgent(),
    faq: new FAQAgent(),
    coldTraffic: new ColdTrafficAgent(),
    website: new WebsiteAgent(),
    seopages: new SeopagesAgent(),
    languages: new LanguagesAgent(),
    contentOverrides: new ContentOverridesAgent(),
    seqOffers: new SeqOffersAgent(),
    affiliateKitItems: new AffiliateKitItemAgent(),
};